import {register, init, locale} from 'svelte-i18n';

import langSettings from '../../../locale/langSettings.json';

const LOCALE_STORAGE_KEY = 'locale';
const availableLocales = Object.keys(langSettings.languagesAvailableForUser);

availableLocales.forEach(lang => {
    register(lang, () => import(`../../../locale/${lang}/e-toll.json`));
});

/**
 * `localStorage` bywa niedostępny (tryb prywatny, jsdom w testach), a zapisana wartość może być
 * nieaktualnym kodem języka, którego już nie wydajemy - w obu przypadkach wracamy do domyślnego.
 */
function readStoredLocale() {
    try {
        const stored = localStorage.getItem(LOCALE_STORAGE_KEY);

        return availableLocales.includes(stored) ? stored : null;
    } catch (e) {
        return null;
    }
}

init({
    fallbackLocale: 'pl',
    initialLocale: readStoredLocale() || langSettings.defaultLanguage,
});

/**
 * Wybór języka musi trafić do `localStorage`, bo trzy niezależne miejsca czytają dokładnie ten klucz:
 * - `ApiConfig.getHeaders()` (vendor) wysyła go jako nagłówek `Accept-Language`, czyli to jedyny
 *   kanał, którym backend dowiaduje się o języku (cookie `ln` nie dolatuje przy różnych hostach),
 * - `main.ts` i `App.svelte` doklejają z niego `?ln=` przy przekierowaniu na stronę logowania.
 * Bez tego zapisu nagłówek leciał jako `null`, a wybór języka nie przeżywał odświeżenia strony.
 */
locale.subscribe(value => {
    if (!value || !availableLocales.includes(value)) {
        return;
    }
    try {
        localStorage.setItem(LOCALE_STORAGE_KEY, value);
    } catch (e) {
        console.warn('loadLocalesAsync: nie udało się zapisać języka w localStorage', e);
    }
});

// https://github.com/kaisermann/svelte-i18n/blob/main/docs/Methods.md
// https://github.com/kaisermann/svelte-i18n/blob/main/docs/Locale.md
